export enum DecimalAndSexagesimalScale {
  DECIMAL = 'DECIMAL',
  SEXAGESIMAL = 'SEXAGESIMAL',
}
